<div
  class="flex max-h-[90vh] flex-col overflow-hidden rounded-2xl bg-card shadow-xl dark:bg-zinc-900"
  [overlayLoader]="pageLoader">
  <div class="dialog-header sticky top-0 z-10 shrink-0 !m-0 !px-6 !py-4 bg-primary text-white shadow-sm">
    <div class="flex items-start gap-3 min-w-0">
      <div class="flex-shrink-0 w-11 h-11 rounded-xl bg-white/15 flex items-center justify-center">
        <mat-icon class="icon-size-6 !text-white" [svgIcon]="'heroicons_outline:phone'"></mat-icon>
      </div>
      <div class="dialog-title min-w-0">
        <h2 class="!text-white truncate">Phone Directory</h2>
        <p class="dialog-subtitle !text-white/80 truncate">Look up employees, business partners, and contacts</p>
      </div>
    </div>
    <button
      mat-icon-button
      type="button"
      class="shrink-0 !text-white hover:!bg-white/10"
      aria-label="Close dialog"
      (click)="close()">
      <mat-icon class="!text-white">close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="!m-0 min-h-0 flex-1 overflow-hidden !px-6 !py-5 min-w-0 flex flex-col">
    <div
      class="phone-directory-dialog-table-card bg-card rounded-2xl overflow-hidden border border-slate-300 dark:border-zinc-600 flex flex-col flex-1 min-h-[420px]">
      <div
        class="shrink-0 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between px-4 py-3.5 sm:px-5 border-b border-slate-200/70 dark:border-zinc-700/60">
        <button
          mat-stroked-button
          type="button"
          class="!rounded-xl !border-slate-200 dark:!border-zinc-600 shrink-0 self-start"
          [matMenuTriggerFor]="sourceFilterMenu">
          <span class="inline-flex items-center gap-2">
            <span class="inline-flex items-center">
              <span class="text-sm text-secondary">Source:</span>
              <span class="ms-1 text-sm font-semibold text-neutral-900 dark:text-white">{{ sourceLabelFilter }}</span>
            </span>
            <mat-icon class="icon-size-4 text-secondary" [svgIcon]="'heroicons_outline:chevron-down'"></mat-icon>
          </span>
        </button>

        <div class="flex items-center gap-2 min-w-0 w-full sm:w-auto sm:justify-end">
          <mat-form-field
            class="phone-directory-dialog-search fuse-mat-dense w-full sm:w-72 min-w-0 shrink"
            subscriptSizing="dynamic"
            floatLabel="never">
            <mat-icon matPrefix class="icon-size-5 text-secondary" [svgIcon]="'heroicons_outline:magnifying-glass'"></mat-icon>
            <input
              matInput
              [(ngModel)]="keyword"
              placeholder="Search name or phone…"
              aria-label="Search name or phone"
              (ngModelChange)="onKeywordChange()"
              (keyup.enter)="onKeywordChange()" />
            @if (keyword) {
              <button mat-icon-button matSuffix type="button" aria-label="Clear search" (click)="clearKeyword()">
                <mat-icon class="icon-size-4" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
              </button>
            }
          </mat-form-field>
        </div>
      </div>

      <div class="phone-directory-dialog-table-scroll min-h-0 flex-1 overflow-x-auto overflow-y-auto">
        <table mat-table [dataSource]="rows" class="phone-directory-dialog-table w-full min-w-[980px]">
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef>Type</th>
            <td mat-cell *matCellDef="let row">
              <span
                class="inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold whitespace-nowrap"
                [ngClass]="sourceBadgeClass(row.sourceType)">
                {{ sourceLabel(row.sourceType) }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let row">
              <div class="flex items-center gap-2 min-w-0">
                <span class="font-semibold text-neutral-900 dark:text-white truncate">{{ cell(row.displayName) }}</span>
                @if (row.isPrimary === true) {
                  <span
                    class="shrink-0 inline-flex items-center rounded-full bg-primary/10 px-2 py-0.5 text-[11px] font-semibold text-primary">
                    Primary
                  </span>
                }
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="related">
            <th mat-header-cell *matHeaderCellDef>Related</th>
            <td mat-cell *matCellDef="let row" class="text-secondary">{{ cell(row.secondaryName) }}</td>
          </ng-container>

          <ng-container matColumnDef="code">
            <th mat-header-cell *matHeaderCellDef>Code</th>
            <td mat-cell *matCellDef="let row" class="text-secondary">{{ cell(row.code) }}</td>
          </ng-container>

          <ng-container matColumnDef="phone">
            <th mat-header-cell *matHeaderCellDef>Phone</th>
            <td mat-cell *matCellDef="let row" class="text-secondary whitespace-nowrap">{{ cell(row.phone) }}</td>
          </ng-container>

          <ng-container matColumnDef="mobile">
            <th mat-header-cell *matHeaderCellDef>Mobile</th>
            <td mat-cell *matCellDef="let row" class="text-secondary whitespace-nowrap">{{ cell(row.mobile) }}</td>
          </ng-container>

          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef>Email</th>
            <td mat-cell *matCellDef="let row" class="text-secondary">
              <span class="block max-w-[14rem] truncate">{{ cell(row.email) }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="role">
            <th mat-header-cell *matHeaderCellDef>Role / dept</th>
            <td mat-cell *matCellDef="let row" class="text-secondary">{{ cell(row.departmentOrRole) }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns" class="phone-directory-dialog-header-row"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            class="phone-directory-dialog-data-row hover:bg-slate-50 dark:hover:bg-zinc-800/60"
            (click)="openRow(row)"></tr>
          <tr *matNoDataRow>
            <td class="py-16 text-center" [attr.colspan]="displayedColumns.length">
              <div class="flex flex-col items-center justify-center gap-3 text-slate-500">
                <mat-icon class="text-5xl text-slate-300">{{ emptyIcon }}</mat-icon>
                <div class="text-base font-semibold">{{ emptyTitle }}</div>
              </div>
            </td>
          </tr>
        </table>
      </div>

      <div
        class="phone-directory-dialog-paginator sticky bottom-0 z-20 shrink-0 border-t border-slate-200/70 bg-card dark:border-zinc-700/60 dark:bg-zinc-900">
        <app-text-paginator
          [length]="totalRecords"
          [pageSize]="pageSize"
          [pageIndex]="pageIndex"
          (page)="onPageChange($event)">
        </app-text-paginator>
      </div>
    </div>
  </mat-dialog-content>

  <div class="sticky bottom-0 z-10 shrink-0 bg-card px-6 pb-5 pt-2 dark:bg-zinc-900">
    <mat-dialog-actions align="end" class="!m-0 !p-0 min-h-0 gap-2">
      <button mat-stroked-button type="button" (click)="close()">Close</button>
    </mat-dialog-actions>
  </div>
</div>

<mat-menu #sourceFilterMenu="matMenu">
  @for (opt of sourceOptions; track opt.value) {
    <button mat-menu-item type="button" (click)="setSource(opt.value)">
      <span [class.font-semibold]="source === opt.value">{{ opt.label }}</span>
    </button>
  }
</mat-menu>
